// extracted by mini-css-extract-plugin
export default {"form":"InputMessage_form__3LjKC","inputMessage":"InputMessage_inputMessage__hBKFu","submit":"InputMessage_submit__rqRXH"};